import adt from '../../images/fleet/thumbs/articulated_dump_truck.jpg'
import bulldozer from '../../images/fleet/thumbs/bulldozer.jpg'
import compactor from '../../images/fleet/thumbs/compactor.jpg'
import drill_rig from '../../images/fleet/thumbs/drill_rig.jpg'
import excavator from '../../images/fleet/thumbs/excavator.jpg'
import fuel_bowser from '../../images/fleet/thumbs/fuel_bowser.jpg'
import hydraulic_breaker from '../../images/fleet/thumbs/hydarulic_breaker.jpg'
import lighting_plant from '../../images/fleet/thumbs/lighting_plant.jpg'
import lbt from '../../images/fleet/thumbs/low_bed_truck.png'
import motor_grader from '../../images/fleet/thumbs/motor_grader.jpg'
import tipper_truck from '../../images/fleet/thumbs/tipper_truck.jpg'
import water_bowser from '../../images/fleet/thumbs/water_bowser.jpg'
import water_pump from '../../images/fleet/thumbs/water_pump.jpg'
import wheel_loader from '../../images/fleet/thumbs/wheel_loader.jpg'

export const fleet_thumbs = [
    {
        'id': 'excavtors',
        "name": "Excavators",
        "type": "Industrial",
        "link": "#",
        "image": excavator,
    },
    {
        'id': 'hydraulic-breakers',
        "name": "Articulated Dump Trucks",
        "type": "Industrial",
        "link": "#",
        "image": adt,
    },
    {
        'id': 'motor-graders',
        "name": "Bulldozers",
        "type": "Industrial",
        "link": "#",
        "image": bulldozer,
    },
    {
        'id': 'vibrating-compactors',
        "name": "Vibrating Compactors",
        "type": "Industrial",
        "link": "#",
        "image": compactor,
    },
    {
        'id': 'wheel-loaders',
        "name": "Drill Rigs",
        "type": "Industrial",
        "link": "#",
        "image": drill_rig,
    },
    {
        'id': 'bulldozers',
        "name": "Fuel Bowser",
        "type": "Industrial",
        "link": "#",
        "image": fuel_bowser,
    },
    {
        'id': 'low-bed-trucks',
        "name": "Hydraulic Breakers/Hammer",
        "type": "Industrial",
        "link": "#",
        "image": hydraulic_breaker,
    },
    {
        'id': 'drill-rigs',
        "name": "Lighting Plants",
        "type": "Industrial",
        "link": "#",
        "image": lighting_plant,
    },
    {
        'id': 'water-bowsers',
        "name": "Low Bed Trucks",
        "type": "Industrial",
        "link": "#",
        "image": lbt,
    },
    {
        'id': 'dump-trucks',
        "name": "Motor Graders",
        "type": "Industrial",
        "link": "#",
        "image": motor_grader,
    },
    {
        'id': 'tippers',
        "name": "Tipper Trucks",
        "type": "Industrial",
        "link": "#",
        "image": tipper_truck,
    },
    {
        'id': 'fuel-bowsers',
        "name": "Water Bowsers",
        "type": "Industrial",
        "link": "#",
        "image": water_bowser,
    },
    {
        'id': 'light-plants',
        "name": "Water Pumps",
        "type": "Industrial",
        "link": "#",
        "image": water_pump,
    },
    {
        'id': 'water-pumps',
        "name": "Wheel Loaders",
        "type": "Industrial",
        "link": "#",
        "image": wheel_loader,
    },
]